import { useEffect, useState } from "react";

export const useResizeObserver = (ref) => {
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const element = ref.current;
        if (!element) return;

        // ResizeObserver callback
        const observer = new ResizeObserver((entries) => {
            // update width
            if (entries[0]) {
                setDimensions({
                    width: entries[0].contentRect.width,
                    height: entries[0].contentRect.height,
                });
            }
        });

        observer.observe(element);
        return () => {
            observer.unobserve(element);
        };
    }, [ref]);
    return dimensions;
};
